<template>
    <main class="news all_posts">

        <article class="news news2">
            <ArticleLogo />
        </article>
        <ul class=" fixtures">

            <TeamResult v-for="(game, index) in games" :key="index" :game="game" :screen="screen" />
            <div v-if="!user_login_info" class="p-reg2">
                please <router-link class="return_to_login" :to="{ name: 'login' }">Login</router-link> or
                <router-link class="return_to_register" :to="{ name: 'register' }">Register</router-link> to vote

            </div>
        </ul>
        <ul class="squad">
            <SquadPlayers :players="players" :motm="true" :userVote="userVote" @voteDone="loadPage" />
        </ul>
        <ul v-if="players && players.length < 1" class="no_players">available players for voting will be shown in a
            short time</ul>

    </main>
</template>

<script>
import ArticleLogo from '@/components/ArticleLogo.vue'
import TeamResult from '@/components/team/TeamResult.vue'
import SquadPlayers from '@/components/team/SquadPlayers.vue'
// import NewsSubMenu from '@/components/team/NewsSubMenu.vue'

export default {
    name: 'MilanFixtures',
    components: { ArticleLogo, TeamResult, SquadPlayers },
    data() {
        return {
            games: null,
            screen: true,
            players: null,
            userVote: ''

        }
    },
    inject: ['backendServer', 'currentHost', 'user_login_info'],

    methods: {
        loadPage() {
            fetch(this.backendServer() + '/motm-game', {
                method: "GET",
                credentials: "include"
            })
                .then((response) => response.json())
                .then((data) => {
                    this.games = data.match;
                    this.players = data.players
                    this.userVote = data.user_vote
                });
        }
    },
    mounted() {

        this.loadPage()

    }

}
</script>

<style>
.p-reg2 {
    background: #d2d2d2;
    font-size: .9em;
    text-align: center;
    border-radius: 7px;
    height: 30px;
    line-height: 30px;
    width: 245px;
    margin-bottom: 6px;
}

.p-reg2 a {
    text-decoration: none;
}
</style>